/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { clickTrack } from '@/utils/analytics/clickTrack';
import type { CustomLinkName, PDPComparisonAnalytics } from '@/types/analytics';
import { type ProductSkuDetails } from '@/features/product';
import root from 'window-or-global';

export const trackPDPComparisonAddToCart = ({
  skuId,
  partNumber,
  availableQty,
  fulfillmentTypeId,
  analyticsData: { originalPartTypeId, repositoryId, brandName },
  skuDetails,
  price,
}: {
  skuId: string;
  partNumber: string | null;
  availableQty: number | undefined;
  fulfillmentTypeId: number | undefined;
  analyticsData: PDPComparisonAnalytics;
  skuDetails: ProductSkuDetails | undefined;
  price: number | undefined;
}) => {
  const pdpComparisonAddToCart: CustomLinkName = 'PDP:AZ Product:SEO PDP Comparison Cart Addition';
  clickTrack({
    customLinkName: pdpComparisonAddToCart,
    eventType: 'addToCart',
    originalPartTypeIdList: originalPartTypeId ? [originalPartTypeId] : [],
    pageName: root.utag_data?.pageName ?? '',
    pageType: root.utag_data?.pageType ?? '',
    productAvailableQuantityList: availableQty !== undefined ? [availableQty] : [],
    productBrandList: brandName ? [brandName] : [],
    productCorePriceList: skuDetails ? [`${skuDetails.skuPricingAndAvailability.corePrice}`] : [],
    productFulfillmentTypeList: fulfillmentTypeId ? [`${fulfillmentTypeId}`] : [],
    productFindingMethod: 'SEO PDP Product Comparison',
    productIdList: [skuId],
    productPartNumberList: partNumber ? [partNumber] : [],
    productPriceList: price !== undefined ? [price.toFixed(2)] : [],
    productRecommendationTypeList: 'AZ Product',
    productRepositoryIdList: repositoryId ? [repositoryId] : [],
    productStrikeThroughPricing: [
      skuDetails?.skuPricingAndAvailability.discountedPrice ? '1' : '0',
    ],
  });
};
